class StickyATC extends HTMLElement {
    constructor() {
        super();
        this.footer = document.querySelector('footer');
        this.desktopBuyButtons = document.querySelector('.buy-buttons-desktop');
        this.mobileBuyButtons = document.querySelector('.buy-buttons-mobile');
    }

    connectedCallback() {
        this.watch();
    }

    hide() {
        this.classList.remove("atc-active")
    }

    show() {
        this.classList.add("atc-active")
    }

    watch() {
        // if footer is visible or the buy-buttons class is visible then hide the sticky add to cart else show it
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting || window.top.scrollY < 200) {
                    this.hide();
                } else {
                    this.show();
                }
            });
        }, { threshold: 0.3 });
        observer.observe(this.footer);
        // if the screen is desktop then use .buy-buttons-desktop else use .buy-buttons-mobile
        if (window.innerWidth > 768) {
            observer.observe(this.desktopBuyButtons);
        } else {
            observer.observe(this.mobileBuyButtons);
        }
    }
}
customElements.define('sticky-atc', StickyATC);